import type { FormControl, NonNullableFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { type ControlInterface, selectControlValue } from '@comparit/core';
import { tap } from 'rxjs';
import type { Step8FormInput } from '../../../interfaces';
import type { ZusatzbausteinKey } from '../options/zusatzbaustein-cards';

/** The Sparte takes a Gesamtwert der Fahrräder of 1 to 50.000 €. */
const FAHRRADWERT_MIN = 1;
const FAHRRADWERT_MAX = 50000;

export class Step8Form {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: Step8FormInput | null
  ) {
    this.fahrraddiebstahlValidation$.subscribe();
  }

  ctrls: ControlInterface<Step8FormInput> = {
    elementar: this.fb.control<boolean>(this.defaultValue?.elementar ?? false),
    glas: this.fb.control<boolean>(this.defaultValue?.glas ?? false),
    fahrraddiebstahlwert: this.fb.control<number | null>(
      this.defaultValue?.fahrraddiebstahlwert ?? null
    ),
    // Inside the group so it is persisted: switching the card on without typing a Wert yet is a
    // real state, and deriving it from `fahrraddiebstahlwert != null` loses it on reload.
    fahrraddiebstahl: this.fb.control<boolean>(
      this.defaultValue?.fahrraddiebstahl ?? this.defaultValue?.fahrraddiebstahlwert != null
    ),
  };

  public fahrraddiebstahl$ = selectControlValue(this.ctrls.fahrraddiebstahl);

  private fahrraddiebstahlValidation$ = this.fahrraddiebstahl$.pipe(
    tap(isCovered => {
      if (isCovered) {
        this.ctrls.fahrraddiebstahlwert.setValidators([
          Validators.required,
          Validators.min(FAHRRADWERT_MIN),
          Validators.max(FAHRRADWERT_MAX),
        ]);
      } else {
        this.ctrls.fahrraddiebstahlwert.clearValidators();
        if (this.ctrls.fahrraddiebstahlwert.value !== null) {
          this.ctrls.fahrraddiebstahlwert.setValue(null);
        }
      }
      this.ctrls.fahrraddiebstahlwert.updateValueAndValidity();
    })
  );

  /** One control per card, so the template loops without branching on the key. */
  public toggles: Record<ZusatzbausteinKey, FormControl<boolean | null>> = {
    elementar: this.ctrls.elementar,
    glas: this.ctrls.glas,
    fahrraddiebstahl: this.ctrls.fahrraddiebstahl,
  };

  public fg = this.fb.group(this.ctrls);
}
